import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://sheetmate-452111.web.app';

interface SeoHeadProps {
  title: string;
  description: string;
  path?: string;
  keywords?: string[];
  structuredData?: Record<string, unknown> | Array<Record<string, unknown>>;
  noIndex?: boolean;
}

const normalizePath = (path = '/') => (path.startsWith('/') ? path : `/${path}`);

export const SeoHead = ({
  title,
  description,
  path = '/',
  keywords,
  structuredData,
  noIndex = false
}: SeoHeadProps) => {
  const canonicalUrl = `${SITE_URL}${normalizePath(path)}`;
  const structuredDataItems = Array.isArray(structuredData)
    ? structuredData
    : structuredData
      ? [structuredData]
      : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${SITE_URL}/screenshot.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      {structuredDataItems.map((item, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
